module.exports = __webpack_public_path__ + "1485fc4860744ca4b39fed2a583b1c90.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/Gauge.png
// module id = 2253
// module chunks = 0